import React, { Component, useContext } from 'react';
import Select from 'react-select';
import { isLoggedIn, fetchSignedMessage, getSessionValue, businessIdHeader, postMethod, getMethod, httpOKsuccess, cssFormInputLabel, cssFormInputNumber, cssFormInputText, cssFormInputFile, cssFormInputButton, cssFormInput, postAttachment, cssFormInputDropdown, cssFormInline, cssError, fileFieldType, numberField, textField, cssFormCheckBox, checkBox, standardMinusTextLength, notificationTitleLength, notificationBodyLength, longTextLength, buttonType, loyaltyOffersSession, posIntegration, timeField, cssContactRequestSection, cssContactRequestField, cssContactRequestFieldActions } from './Library';
import CurrencyInput from 'react-currency-input-field';
import ShowHelp from '../img/help-icon.png';
import HideHelp from '../img/help-close-icon.png';
import { NavMenu } from '../components/NavMenu';
import ReactDOM from 'react-dom';
import DualBallSpinner from '../img/dual-ball-1s-100px.gif';
import JoditEditor from 'jodit-react';


const targetSpend = "sp";

const rewardPercentage = "rp";
const rewardNominal = "rn";

const messageDelayYearsId = "messageDelayYears";
const messageDelayMonthsId = "messageDelayMonths";
const messageDelayDaysId = "messageDelayDays";
const messageDelayDayPart = "messageDelayDayPart";

const voucherType = "voucher";
const messageType = "message"

const loyaltyOfferTargets = [{ key: targetSpend, value: targetSpend, label: 'Spend Requirement' }];
const loyaltyOfferRewards = [{ key: rewardNominal, value: rewardNominal, label: 'Amount off next bill' }, {
	key: rewardPercentage, value: rewardPercentage, label: 'Percentage off next bill'
}];

const loyaltyOfferPeriodRewardClassName = "LoyaltyOfferExpiryPeriod";
const referralProgramClassName = "LoyaltyReferralProgram";

export class LoyaltyOfferRulesOption {
	constructor(key, text) {
		this.label = text;
		this.value = key;
	}
}

export class ConsumerFieldOption {
	constructor(key, text) {
		this.label = text;
		this.value = key;
	}
}
export class LoyaltyOffer extends Component {

	constructor(props) {
		super(props)
		this.state = {
			loyaltyOfferTarget: '',
			loyaltyOfferDiscount: '',
			businessId: '',
			signUpAlertText: '',
			loyaltyOfferStandardRuleId: null,
			loyaltyOfferRuleId: null,
			loyaltyOfferLifetimeId: null,
			loyaltyOfferPeriodRewardId: null,
			loyaltyReferralProgramId: null,
			numberOfPoints: null,
			offerDetails: '',
			displayNextSteppedOfferDescription: false,
			percentageOff: null,
			spendRequirement: null,
			loyaltyOfferRuless: [],
			consumerFields: [],
			steppedOfferTiers: [],
			followUpMessages: [],
			years: null,
			months: null,
			days: null,
			referrerFollowUpTemplates: [],
			refereeFollowUpTemplates: [],
			referrerReward: null,
			refereeReward: null,
			loading: true,
			errorNumberOfPoints: '',
			errorPercentageOff: '',
			errorSpendRequirement: '',
			errorOfferDetails: '',
			errorLoyaltyOfferId: '',
			errorTimePeriod: '',
			helpVisible: false,
			submitButtonDisabled: false
		};
		this.handleInputChange = this.handleInputChange.bind(this);
	}



	async componentDidMount() {
		this.getLoyaltyOfferRulesData();
		this.getConsumerFieldsData();
		await isLoggedIn();
		this.setState({ loading: false })
	}


	handleInputChange = (event) => {
		const target = event.target;
		const value = target.type === 'checkbox' ? target.checked : target.type === numberField ? parseInt(target.value) : target.value;
		const name = target.name;

		this.setState({
			[name]: value
		});
	}

	handleCurrencyChange = (value) => {

		this.setState({
			spendRequirement: value
		});
	}

	handleDropDownChange = (e, data) => {
		const name = data.name;
		this.setState({
			[name]: e.value
		})
	}

	handleFileChange = (event) => {
		this.setState({
			attachment: event.target.files[0]
		})
	}

	handleSubmit = (event) => {
		if (this.state.loyaltyOfferRuleId == this.state.loyaltyReferralProgramId) {
			this.state.numberOfPoints = 1;
		}

		let isValid = this.handleValidation();

		for (let i = 0; i < this.state.steppedOfferTiers.length; i++) {
			if (!this.handleSteppedOfferValidation(this.state.steppedOfferTiers[i])) {
				isValid = false;
			}
		}

		event.preventDefault();
		var apiMethod = "loyaltyoffer";


		if (isValid) {
			var responseLabel = document.getElementById("response");
			ReactDOM.render('', responseLabel);
			this.setState({ loading: true, submitButtonDisabled: true });

			var loyaltyOffer = {
				signUpAlertText: this.state.signUpAlertText,
				businessId: getSessionValue(businessIdHeader),
				loyaltyOfferRuleId: this.state.loyaltyOfferRuleId,
				offerDetails: this.state.offerDetails,
				requiredNumberOfMatches: this.state.numberOfPoints,
				displayNextSteppedOfferDescription: this.state.displayNextSteppedOfferDescription
			};

			if (this.state.loyaltyOfferRuleId == this.state.loyaltyOfferPeriodRewardId) {
				loyaltyOffer.years = this.state.years;
				loyaltyOffer.months = this.state.months;
				loyaltyOffer.days = this.state.days;

				apiMethod = loyaltyOfferPeriodRewardClassName.toLowerCase();
			}

			if (this.state.loyaltyOfferRuleId == this.state.loyaltyReferralProgramId) {
				loyaltyOffer.referrerFollowUpTemplates = this.state.referrerFollowUpTemplates.map((item) => this.followUpMessageFromState(item));
				loyaltyOffer.refereeFollowUpTemplates = this.state.refereeFollowUpTemplates.map((item) => this.followUpMessageFromState(item));
				loyaltyOffer.referrerReward = this.state.referrerReward;
				loyaltyOffer.refereeReward = this.state.refereeReward;

				apiMethod = referralProgramClassName.toLowerCase();
			}

			if (this.state.attachment != null) {
				this.state.attachmentPath = postAttachment(this.state.attachment);
				messageData.attachmentPath = 'https://' + process.env.REACT_APP_MESSAGE_BUCKET_NAME + '.s3.' + process.env.REACT_APP_AWS_REGION + '.amazonaws.com/' + this.state.attachmentPath;
			}

			switch (this.state.loyaltyOfferTarget) {
				case targetSpend:
					var loyaltyOfferSpendRequirement = {
						spendRequirement: this.state.spendRequirement
					};
					loyaltyOffer.target = loyaltyOfferSpendRequirement;
					break;
			}

			switch (this.state.loyaltyOfferDiscount) {
				case rewardPercentage:
					var loyaltyDiscountPercentageReward = {
						percentageOff: this.state.percentageOff
					};
					loyaltyOffer.reward = loyaltyDiscountPercentageReward;
					break;
				case rewardNominal:
					var loyaltyDiscountNominalAmountReward = {
						discount: this.state.nominalAmountOff
					};
					loyaltyOffer.reward = loyaltyDiscountNominalAmountReward;
					break;
			}

			if (this.state.steppedOfferTiers.length > 0) {
				loyaltyOffer.steppedRewards = [];
			}

			for (let i = 0; i < this.state.steppedOfferTiers.length; i++) {
				const offerTier = this.state.steppedOfferTiers[i];
				var loyaltySteppedOfferTier = {
					numberOfStamps: offerTier.numberOfStamps
				}

				if (offerTier.icon != null) {
					offerTier.iconPath = postAttachment(offerTier.icon);
					loyaltySteppedOfferTier.iconPath = 'https://' + process.env.REACT_APP_MESSAGE_BUCKET_NAME + '.s3.' + process.env.REACT_APP_AWS_REGION + '.amazonaws.com/' + offerTier.iconPath;
				}

				if (offerTier.redeemedIcon != null) {
					offerTier.redeemedIconPath = postAttachment(offerTier.redeemedIcon);
					loyaltySteppedOfferTier.redeemedIconPath = 'https://' + process.env.REACT_APP_MESSAGE_BUCKET_NAME + '.s3.' + process.env.REACT_APP_AWS_REGION + '.amazonaws.com/' + offerTier.iconPath
				}

				switch (offerTier.loyaltyOfferDiscount) {
					case rewardPercentage:
						var loyaltyDiscountPercentageReward = {
							percentageOff: offerTier.percentageOff
						};
						loyaltySteppedOfferTier.reward = loyaltyDiscountPercentageReward;
						break;
					case rewardNominal:
						var loyaltyDiscountNominalAmountReward = {
							discount: offerTier.nominalAmountOff
						}
						loyaltySteppedOfferTier.reward = loyaltyDiscountNominalAmountReward;
				}
				loyaltySteppedOfferTier.tierDetails = offerTier.tierDetails;
				loyaltyOffer.steppedRewards.push(loyaltySteppedOfferTier);
			}

			if (this.state.followUpMessages.length > 0) {
				loyaltyOffer.followUpMessagesAndVouchers = [];
			}

			for (let i = 0; i < this.state.followUpMessages.length; i++) {

				const followUpMessageState = this.state.followUpMessages[i];

				loyaltyOffer.followUpMessagesAndVouchers.push(this.followUpMessageFromState(followUpMessageState));
			}

			fetchSignedMessage(JSON.stringify(loyaltyOffer), apiMethod, postMethod).then(response => {
				if (response.status == httpOKsuccess) {
					ReactDOM.render(<label className={cssFormInputLabel}>Loyalty Offer Saved.</label>, responseLabel);
					this.setState({ loading: false, submitButtonDisabled: false });
				} else {
					ReactDOM.render(<label className={cssFormInputLabel}>Loyalty Offer saving failed. Please try again later.</label>, responseLabel);
					this.setState({ loading: false, submitButtonDisabled: false });
				}
			}).catch(error => {
				this.setState({ loading: false, submitButtonDisabled: false });
				ReactDOM.render(<label className={cssFormInputLabel}>Loyalty Offer saving failed. Please try again later.</label>, responseLabel);
				this.setState({ loading: false, submitButtonDisabled: false });
			});

			const loyaltyOffers = JSON.parse(sessionStorage.getItem(loyaltyOffersSession));
			if (loyaltyOffers == null) {
				const offers = [loyaltyOffer];
				sessionStorage.setItem(loyaltyOffersSession, JSON.stringify(offers))
			} else {
				loyaltyOffers.push(loyaltyOffer);
				sessionStorage.setItem(loyaltyOffersSession, JSON.stringify(loyaltyOffers));
			}
		}
	}

	followUpMessageFromState(followUpMessageState) {
		if (followUpMessageState.attachment != null) {
			followUpMessageState.attachmentPath = postAttachment(followUpMessageState.attachment);
		}

		var followUpMessage = {
			$type: followUpMessageState.$type, //(followUpMessageState.isVoucher ? "voucher" : "message"),
			alertTitle: followUpMessageState.alertTitle,
			alertBody: followUpMessageState.alertBody,
			htmlMessage: followUpMessageState.htmlMessage,
			attachmentPath: followUpMessageState.attachmentPath,
			messageLink: followUpMessageState.messageLink,
			messageDelayDayPart: followUpMessageState.messageDelayDayPart,
			messageDelayDays: followUpMessageState.messageDelayDays,
			messageDelayMonths: followUpMessageState.messageDelayMonths,
			messageDelayYears: followUpMessageState.messageDelayYears,
			voucherValidFromDayPart: followUpMessageState.voucherValidFromDayPart,
			voucherValidFromDays: followUpMessageState.voucherValidFromDays,
			voucherValidFromMonths: followUpMessageState.voucherValidFromMonths,
			voucherValidFromYears: followUpMessageState.voucherValidFromYears,
			voucherLifeDayPart: followUpMessageState.voucherLifeDayPart,
			voucherLifeDays: followUpMessageState.voucherLifeDays,
			voucherLifeMonths: followUpMessageState.voucherLifeMonths,
			voucherLifeYears: followUpMessageState.voucherLifeYears
		}

		if (followUpMessageState.$type == messageType) {
			followUpMessage.contactRequestFields = (followUpMessageState.contactRequestFields || []).map((field) => ({
				consumerFieldId: field.consumerFieldId,
				fieldTitle: field.fieldTitle,
				displayOrder: field.displayOrder,
				required: field.required,
				validationMessage: field.validationMessage
			}));
			followUpMessage.contactRequestFormTitle = followUpMessageState.contactRequestFormTitle;
			followUpMessage.contactRequestButtonText = followUpMessageState.contactRequestButtonText;
		}

		return followUpMessage;
	}

	handleAddSteppedOfferTier = (event) => {

		this.setState({
			steppedOfferTiers: this.state.steppedOfferTiers.concat(
				[{ numberOfStamps: 0, percentageOff: 0.00, errorNumberOfStamps: '', errorTierDetails: '' }]
			)
		})

	}

	handleSteppedOfferChange = (elementIndex) => (event) => {

		let steppedOfferTiers = this.state.steppedOfferTiers.map((item, i) => {
			if (elementIndex !== i) return item
			return { ...item, [event.target.name]: event.target.type === numberField ? Number(event.target.value) : event.target.value }
		})

		this.setState({ steppedOfferTiers })
	}

	handleSteppedFileChange = (elementIndex) => (event) => {

		let steppedOfferTiers = this.state.steppedOfferTiers.map((item, i) => {
			if (elementIndex !== i) return item
			return { ...item, [event.target.name]: event.target.files[0] }
		})

		this.setState({ steppedOfferTiers })
	}

	handleRemoveSteppedOffer = (elementIndex) => (event) => {
		this.setState({
			steppedOfferTiers: this.state.steppedOfferTiers.filter((item, i) => {
				return elementIndex != i
			})
		})
	}

	handleSteppedDropDownChange = (elementIndex) => (event) => {
		let steppedOfferTiers = this.state.steppedOfferTiers.map((item, i) => {
			if (elementIndex !== i) return item
			return { ...item, 'loyaltyOfferDiscount': event.key }
		})

		this.setState({ steppedOfferTiers })
	}

	handleSteppedOfferValidation(item) {
		let validated = true;

		if (item.numberOfStamps == null || item.numberOfStamps <= 0) {
			validated = false;
			item.errorNumberOfStamps = "Number of stamps should be greater than zero"
		} else {
			item.errorNumberOfStamps = "";
		}

		if (item.tierDetails == null || item.tierDetails.length == 0) {
			validated = false;
			item.errorTierDetails = "You must provide a description for the tier";
		} else {
			item.errorTierDetails = "";
		}

		return validated;
	}

	handleAddFollowUpMessage = (event) => {

		this.setState({
			followUpMessages: this.state.followUpMessages.concat(
				[{ $type: 'message', alertTitle: '', alertBody: '', htmlMessage: '', attachmentPath: '', messageLink: '', messageDelayDayPart: null, messageDelayDays: null, messageDelayMonths: null, messageDelayYears: null, contactRequestFields: [], contactRequestFormTitle: '', contactRequestButtonText: '' }]
			)
		})

	}

	handleFollowUpMessageChange = (elementIndex) => (event) => {
		if (isNaN(+elementIndex)) {
			let messageTemplate = this.state[elementIndex];
			if (event.target == undefined) {
				messageTemplate['htmlMessage'] = event;
			} else {
				messageTemplate[event.target.name] = event.target.type === numberField ? Number(event.target.value) : event.target.value;
			}
			this.setState({ [elementIndex]: messageTemplate })
		} else {
			let followUpMessages = this.state.followUpMessages.map((item, i) => {
				if (elementIndex !== i) return item
				if (event.target == undefined) {
					if (event.label == undefined) return { ...item, ['htmlMessage']: event }
					return { ...item, ['$type']: event.value }
				} else {
					return { ...item, [event.target.name]: event.targetType === timeField ? event.target.value.getSeconds() : event.target.type === numberField ? Number(event.target.value) : event.target.value }
				}
			});

			this.setState({ followUpMessages });
		}
	}

	handleFollowUpMessageCheckboxChange = (elementIndex) => (event) => {
		let followUpMessages = this.state.followUpMessages.map((item, i) => {
			if (elementIndex !== i) return item
			return { ...item, [event.target.name]: event.target.checked }
		});

		this.setState({ followUpMessages });
	}


	handleFollowUpMessageFileChange = (elementIndex) => (event) => {

		let followUpMessages = this.state.followUpMessages.map((item, i) => {
			if (elementIndex !== i) return item
			return { ...item, [event.target.name]: event.target.files[0] }
		})

		this.setState({ followUpMessages })
	}

	handleRemoveFollowUpMessage = (elementIndex) => (event) => {
		this.setState({
			followUpMessages: this.state.followUpMessages.filter((item, i) => {
				return elementIndex != i
			})
		})
	}

	handleAddNotification = (collectionName) => (event) => {
		this.setState({
			[collectionName]: this.state[collectionName].concat(
				[{ $type: 'message', alertTitle: '', alertBody: '', htmlMessage: '', attachmentPath: '', messageLink: '', messageDelayDayPart: null, messageDelayDays: null, messageDelayMonths: null, messageDelayYears: null, contactRequestFields: [], contactRequestFormTitle: '', contactRequestButtonText: '' }]
			)
		})
	}

	handleNotificationChange = (collectionName, elementIndex) => (event) => {
		if (isNaN(+elementIndex)) {
			let messageTemplate = this.state[elementIndex];
			if (event.target == undefined) {
				messageTemplate['htmlMessage'] = event;
			} else {
				messageTemplate[event.target.name] = event.target.type === numberField ? Number(event.target.value) : event.target.value;
			}
			this.setState({ [elementIndex]: messageTemplate })
		} else {
			let collection = this.state[collectionName].map((item, i) => {
				if (elementIndex !== i) return item
				if (event.target == undefined) {
					if (event.label == undefined) return { ...item, ['htmlMessage']: event }
					return { ...item, ['$type']: event.value }
				} else {
					return { ...item, [event.target.name]: event.targetType === timeField ? event.target.value.getSeconds() : event.target.type === numberField ? Number(event.target.value) : event.target.value }
				}
			});
			this.setState({ [collectionName]: collection });
		}
	}

	handleNotificationCheckboxChange = (collectionName, elementIndex) => (event) => {
		let collection = this.state[collectionName].map((item, i) => {
			if (elementIndex !== i) return item
			return { ...item, [event.target.name]: event.target.checked }
		});
		this.setState({ [collectionName]: collection });
	}

	handleNotificationFileChange = (collectionName, elementIndex) => (event) => {
		let collection = this.state[collectionName].map((item, i) => {
			if (elementIndex !== i) return item
			return { ...item, [event.target.name]: event.target.files[0] }
		})
		this.setState({ [collectionName]: collection })
	}

	handleRemoveNotification = (collectionName, elementIndex) => (event) => {
		this.setState({
			[collectionName]: this.state[collectionName].filter((item, i) => {
				return elementIndex != i
			})
		})
	}

	handleAddContactRequestField = (collectionName, elementIndex) => (event) => {
		let collection = this.state[collectionName].map((item, i) => {
			if (elementIndex !== i) return item
			return {
				...item, contactRequestFields: (item.contactRequestFields || []).concat(
					[{ consumerFieldId: null, fieldTitle: '', displayOrder: (item.contactRequestFields || []).length, required: false, validationMessage: '' }]
				)
			}
		})
		this.setState({ [collectionName]: collection })
	}

	handleContactRequestFieldChange = (collectionName, elementIndex, fieldIndex) => (event) => {
		let collection = this.state[collectionName].map((item, i) => {
			if (elementIndex !== i) return item
			let contactRequestFields = item.contactRequestFields.map((field, fi) => {
				if (fieldIndex !== fi) return field
				return { ...field, [event.target.name]: event.target.type === numberField ? Number(event.target.value) : event.target.value }
			})
			return { ...item, contactRequestFields }
		})
		this.setState({ [collectionName]: collection })
	}

	handleContactRequestFieldDropDownChange = (collectionName, elementIndex, fieldIndex) => (e, data) => {
		let collection = this.state[collectionName].map((item, i) => {
			if (elementIndex !== i) return item
			let contactRequestFields = item.contactRequestFields.map((field, fi) => {
				if (fieldIndex !== fi) return field
				return { ...field, consumerFieldId: e.value }
			})
			return { ...item, contactRequestFields }
		})
		this.setState({ [collectionName]: collection })
	}

	handleContactRequestFieldCheckboxChange = (collectionName, elementIndex, fieldIndex) => (event) => {
		let collection = this.state[collectionName].map((item, i) => {
			if (elementIndex !== i) return item
			let contactRequestFields = item.contactRequestFields.map((field, fi) => {
				if (fieldIndex !== fi) return field
				return { ...field, required: event.target.checked }
			})
			return { ...item, contactRequestFields }
		})
		this.setState({ [collectionName]: collection })
	}

	handleRemoveContactRequestField = (collectionName, elementIndex, fieldIndex) => (event) => {
		let collection = this.state[collectionName].map((item, i) => {
			if (elementIndex !== i) return item
			return { ...item, contactRequestFields: item.contactRequestFields.filter((field, fi) => fieldIndex != fi) }
		})
		this.setState({ [collectionName]: collection })
	}

	handleFocusSelect = (event) => {
		event.target.select()
	}

	async getLoyaltyOfferRulesData() {
		try {
			await isLoggedIn();
			const response = await fetchSignedMessage(null, 'loyaltyofferrule', getMethod);
			const data = await response.json();
			this.setState({ loyaltyOfferRuless: data.map((loyaltyOfferRules) => new LoyaltyOfferRulesOption(loyaltyOfferRules.loyaltyOfferRuleId, loyaltyOfferRules.loyaltyOfferRuleName)), loading: false });

			for (var i = 0; i < data.length; i++) {
				var loyaltyOfferRule = data[i];
				if (loyaltyOfferRule.className == 'LoyaltyOffer') {
					this.setState({
						['loyaltyOfferRuleId']: loyaltyOfferRule.loyaltyOfferRuleId
					})
				} else if (loyaltyOfferRule.className == 'LoyaltyOfferLifetimeReward') {
					this.setState({
						['loyaltyOfferLifetimeId']: loyaltyOfferRule.loyaltyOfferRuleId
					});
				} else if (loyaltyOfferRule.className == loyaltyOfferPeriodRewardClassName) {
					this.setState({
						['loyaltyOfferPeriodRewardId']: loyaltyOfferRule.loyaltyOfferRuleId
					});
				} else if (loyaltyOfferRule.className == referralProgramClassName) {
					this.setState({
						['loyaltyReferralProgramId']: loyaltyOfferRule.loyaltyOfferRuleId
					});
				}
			}
		}
		catch (error) {
			console.log(error);
			const networkErrorEmail = "mailto:tech@receiptsandrewards.com?subject=Login%20-%20Network%20Error&body=A%20User%20is%20unable%20to%20logon%20to%20" + window.location.host;
			var messageLabel = document.getElementById("response");
			ReactDOM.render(<label className={cssFormInputLabel} >There appears to be a network error. Please <a href={networkErrorEmail}>contact Receipts and Rewards</a> and we will fix it.</label>, messageLabel);
			this.setState({ loading: false, buttonDisabled: false });
		}
	}

	async getConsumerFieldsData() {
		try {
			await isLoggedIn();
			const response = await fetchSignedMessage(null, 'consumerfield', getMethod);
			const data = await response.json();
			this.setState({ consumerFields: data.map((consumerField) => new ConsumerFieldOption(consumerField.consumerFieldId, consumerField.fieldName)) });
		}
		catch (error) {
			console.log(error);
		}
	}

	DisplayLoyaltyOfferRulesDropdown() {
		const { value } = this.state;
		if (this.state.loyaltyOfferRuless.length == 1) {
			this.state.loyaltyOfferRuleId = this.state.loyaltyOfferRuless[0].value;
			return <div><b>{this.state.loyaltyOfferRuless[0].label}</b></div>;
		}
		else {
			return (<Select
				className={cssFormInputDropdown}
				placeholder='Select Loyalty Offer Rule'
				fluid
				selection
				search
				options={this.state.loyaltyOfferRuless}
				name="loyaltyOfferRuleId"
				onChange={this.handleDropDownChange}
				value={value}
			/>
			);
		}
	}

	handleValidation() {

		let validated = true;

		if (this.state.offerDetails.length == 0) {
			this.setState({ errorSignUpAlertText: "You must include the offer details" });
			validated = false;
		} else {
			this.setState({ errorSignUpAlertText: "" });
		}

		if (this.state.loyaltyOfferRuleId == null) {
			this.setState({ errorLoyaltyOfferId: "You must select a loyalty offer rule" });
			validated = false;
		} else {
			this.setState({ errorLoyaltyOfferId: "" });
		}

		if (this.state.numberOfPoints == null || this.state.numberOfPoints <= 0) {
			this.setState({ errorNumberOfPoints: "You must select the number of points to get the reward" });
			validated = false;
		} else {
			this.setState({ errorNumberOfPoints: "" });
		}

		if (this.state.loyaltyOfferRuleId == this.state.spendAmountForPointOfferId) {
			if (!this.validateNumericNumberIsGreaterThanZero(this.state.spendRequirement, "errorSpendRequirement", "You must have a spend requirement greater than zero")) {
				validated = false;
			}

			if (!this.validateNumericNumberIsGreaterThanZero(this.state.numberOfPoints, "errorNumberOfPoints", "You must have a number of points greater than zero")) {
				validated = false;
			}

			if (!this.validateNumericNumberIsGreaterThanZero(this.state.percentageOff, "errorPercentageOff", "You must have a percentage discount greater than zero")) {
				validated = false;
			}
		}

		if (this.state.loyaltyOfferRuleId == this.state.loyaltyOfferPeriodRewardId) {
			if ((this.state.years ?? 0 + this.state.months ?? 0 + this.state.days ?? 0) == 0) {
				this.setState({ errorTimePeriod: "You must set a time period" });
				validated == false;
			} else {
				this.setState({ errorTimePeriod: "" });
			}
		}

		return validated;
	}

	validateNumericNumberIsGreaterThanZero(valueToValidate, stateForErrorMessage, errorMessage) {

		if (valueToValidate == null || valueToValidate <= 0) {
			this.setState({ [stateForErrorMessage]: errorMessage });
			return false;
		} else {
			this.setState({ [stateForErrorMessage]: "" });
			return true;
		}
	}

	toggleHelp = (event) => {
		this.setState({
			helpVisible: !this.state.helpVisible
		});
	}

	loyaltyOfferTargetDescription() {
		if (this.state.loyaltyOfferRuleId != this.state.loyaltyReferralProgramId) {
			switch (this.state.loyaltyOfferTarget) {
				case targetSpend:
					return <><label className={cssFormInputLabel}>
						Spend Amount for a Point:
						<CurrencyInput name="spendRequirement" className={cssFormInputNumber} allowDecimals="true" allowNegativeValue="false" decimalsLimit="2" decimalScale="2" intlConfig={{ locale: 'en-US', currency: 'GBP' }} value={this.state.spendRequirement} onValueChange={this.handleCurrencyChange} />
					</label>{this.state.errorSpendRequirement && <p className={cssError} >{this.state.errorSpendRequirement}</p>}</>
			}
		}
	}

	loyaltyOfferDiscount(rewardType, rewardsStateRoot) {
		switch (rewardType) {
			case rewardPercentage:
				return <><label className={cssFormInputLabel}>
					Percentage Off When Points Earned:
					<input className={cssFormInputNumber} type={numberField} name="percentageOff" value={rewardsStateRoot.percentageOff} onChange={this.handleInputChange} />
				</label>{this.state.errorPercentageOff && <p className={cssError} >{rewardsStateRoot.errorPercentageOff}</p>}</>
			case rewardNominal:
				return <><label className={cssFormInputLabel}>
					Discount Amount When Points Earned:
					<input className={cssFormInputNumber} type={numberField} name="nominalAmountOff" value={rewardsStateRoot.nominalAmountOff} onChange={this.handleInputChange} />
				</label>{
						this.state.errorPercentageOff && <p className={cssError} >{rewardsStateRoot.errorPercentageOff}</p>
					}</>
		}
	}

	steppedOfferDiscount(i, item) {
		switch (this.state.steppedOfferTiers[i].loyaltyOfferDiscount) {
			case rewardPercentage:
				return <><label className={cssFormInputLabel}>
					Percentage Off When Points Earned:
					<input className={cssFormInputNumber} type={numberField} name="percentageOff" value={item.percentageOff} onChange={this.handleSteppedOfferChange(i)} />
				</label>{this.state.steppedOfferTiers[i].errorPercentageOff && <p className={cssError} >{this.state.steppedOfferTiers[i].errorPercentageOff}</p>}</>
			case rewardNominal:
				return <><label className={cssFormInputLabel}>
					Discount Amount When Points Earned:
					<input className={cssFormInputNumber} type={numberField} name="nominalAmountOff" value={item.nominalAmountOff} onChange={this.handleSteppedOfferChange(i)} />
				</label>{
						this.state.steppedOfferTiers[i].errorPercentageOff && <p className={cssError} >{this.state.steppedOfferTiers[i].errorPercentageOff}</p>
					}</>
		}
	}

	loyaltyOfferSteppedReward(i) {
		return <label className={cssFormInputLabel}>Stepped Offer Reward:<Select
			className={cssFormInputDropdown}
			placeholder='Select Tier Offer Reward'
			fluid
			selection
			search
			options={loyaltyOfferRewards}
			name="loyaltyOfferSteppedDiscount"
			onChange={this.handleSteppedDropDownChange(i)}
		/></label>
	}

	loyaltyOfferFollowUpMessage(i) {
		return <label className={cssFormInputLabel}>Follow up message or voucher:</label>
	}

	referralProgram() {

		return <><label>Referrer's Notifications Details</label><br />
			{this.state.referrerFollowUpTemplates.map((item, i) => this.message(item, i, "referrer" + i, "referrerFollowUpTemplates"))}
			<button type={buttonType} className={cssFormInputButton} onClick={this.handleAddNotification('referrerFollowUpTemplates')}>Add Notification for Referrer</button><br />


			<label>Referee's Voucher and Notification Details</label><br />
			{this.state.refereeFollowUpTemplates.map((item, i) => this.message(item, i, "referee" + i, "refereeFollowUpTemplates"))}
			<button type={buttonType} className={cssFormInputButton} onClick={this.handleAddNotification('refereeFollowUpTemplates')}>Add Notification for Referee</button><br />
		</>

	}

	contactRequestFields(item, i, stateCollectionName) {
		if (item.$type != messageType) return "";

		return <div className={cssContactRequestSection}>
			<label className={cssFormInputLabel}>Contact Request Form Title:<input className={cssFormInputText} name="contactRequestFormTitle" type={textField} maxLength={longTextLength} value={item.contactRequestFormTitle} onChange={this.handleNotificationChange(stateCollectionName, i)} onFocus={this.handleFocusSelect} /></label>
			<label className={cssFormInputLabel}>Contact Request Button Text:<input className={cssFormInputText} name="contactRequestButtonText" type={textField} maxLength={notificationTitleLength} value={item.contactRequestButtonText} onChange={this.handleNotificationChange(stateCollectionName, i)} onFocus={this.handleFocusSelect} /></label>
			{(item.contactRequestFields || []).map((field, fieldIndex) => (
				<div key={fieldIndex} className={cssContactRequestField}>
					<label className={cssFormInputLabel}>Consumer Field:<Select
						className={cssFormInputDropdown}
						placeholder='Select Consumer Field'
						fluid
						selection
						search
						options={this.state.consumerFields}
						name="consumerFieldId"
						onChange={this.handleContactRequestFieldDropDownChange(stateCollectionName, i, fieldIndex)}
						value={this.state.consumerFields.find((consumerField) => consumerField.value == field.consumerFieldId)}
					/></label>
					<label className={cssFormInputLabel}>Field Title:<input className={cssFormInputText} name="fieldTitle" type={textField} maxLength={notificationTitleLength} value={field.fieldTitle} onChange={this.handleContactRequestFieldChange(stateCollectionName, i, fieldIndex)} onFocus={this.handleFocusSelect} /></label>
					<label className={cssFormInputLabel}>Display Order:<input className={cssFormInputNumber} name="displayOrder" type={numberField} value={field.displayOrder} onChange={this.handleContactRequestFieldChange(stateCollectionName, i, fieldIndex)} onFocus={this.handleFocusSelect} /></label>
					<label className={cssFormInputLabel}><input type={checkBox} className={cssFormCheckBox} name="required" checked={field.required} onChange={this.handleContactRequestFieldCheckboxChange(stateCollectionName, i, fieldIndex)} />Required</label>
					{field.required && <label className={cssFormInputLabel}>Validation Message:<input className={cssFormInputText} name="validationMessage" type={textField} maxLength={notificationBodyLength} value={field.validationMessage} onChange={this.handleContactRequestFieldChange(stateCollectionName, i, fieldIndex)} onFocus={this.handleFocusSelect} /></label>}
					<div className={cssContactRequestFieldActions}><button type={buttonType} className={cssFormInputButton} onClick={this.handleRemoveContactRequestField(stateCollectionName, i, fieldIndex)}>Delete Contact Request Field</button></div>
				</div>
			))}
			<div><button type={buttonType} className={cssFormInputButton} onClick={this.handleAddContactRequestField(stateCollectionName, i)}>Add Contact Request Field</button></div>
		</div>
	}

	message(item, i, divKey, stateCollectionName) {
		let deleteButton = this.isReferralMessage(i) ? "" : <div><button type={buttonType} className={cssFormInputButton} onClick={this.handleRemoveNotification(stateCollectionName, i)}>Delete</button></div>
		let voucherOrMessageSelector = this.isReferralMessage(i) ? "" : <label className={cssFormInputLabel}>Message or Voucher<Select className={cssFormInputDropdown} placeholder='Message or Voucher' fluid selection search options={[{ value: messageType, label: 'Message' }, { value: voucherType, label: 'Voucher' }]} onChange={this.handleNotificationChange(stateCollectionName, i)} /></label>
		let attachmentPath = this.isReferralMessage(i) ? "" : <label className={cssFormInputLabel}>Attachment Path:<input className={cssFormInputFile} name="attachment" type={fileFieldType} value={item.attachmentPath} onChange={this.handleNotificationFileChange(stateCollectionName, i)} onFocus={this.handleFocusSelect} /></label>
		let messageLinkField = (item.$type == voucherType) ? "" : <label className={cssFormInputLabel}>Message Link:<input className={cssFormInputText} name="messageLink" type={textField} maxLength={longTextLength} value={item.messageLink} onChange={this.handleNotificationChange(stateCollectionName, i)} onFocus={this.handleFocusSelect} /></label>

		return <div key={divKey}>
			{voucherOrMessageSelector}
			<label className={cssFormInputLabel}>Alert Title:<input className={cssFormInputText} name="alertTitle" type={textField} maxLength={notificationTitleLength} value={item.alertTile} onChange={this.handleNotificationChange(stateCollectionName, i)} onFocus={this.handleFocusSelect} /></label>
			<label className={cssFormInputLabel}>Alert Body:<input className={cssFormInputText} name="alertBody" type={textField} maxLength={notificationBodyLength} value={item.alertBody} onChange={this.handleNotificationChange(stateCollectionName, i)} onFocus={this.handleFocusSelect} /></label>
			{(item.$type == voucherType) ? "" : <label className={cssFormInputFile}>
				HTML Message:
				<JoditEditor
					value={item.htmlMessage}
					onBlur={this.handleNotificationChange(stateCollectionName, i)}
					editorClassName={cssFormInputText}
					tabIndex={3}
					name="htmlMessage"
				/>
			</label>}
			{attachmentPath}
			{messageLinkField}
			{this.isReferralMessage(i) ? "" : this.timePeriodSpecifierForMessage(i, stateCollectionName, "Message Delay", messageDelayYearsId, messageDelayMonthsId, messageDelayDaysId, messageDelayDayPart)}
			{(item.$type == voucherType) ? this.timePeriodSpecifierForMessage(i, stateCollectionName, "Voucher Valid From", "voucherValidFromYears", "voucherValidFromMonths", "voucherValidFromDays", "voucherValidFromDayPart") : ""}
			{(item.$type == voucherType) ? this.timePeriodSpecifierForMessage(i, stateCollectionName, "Voucher Life", "voucherLifeYears", "voucherLifeMonths", "voucherLifeDays", "voucherLifeDayPart") : ""}
			{this.contactRequestFields(item, i, stateCollectionName)}
			{deleteButton}
		</div>
	}

	timePeriodSpecifierForMessage(i, stateCollectionName, title, yearField, monthField, dayField, dayPartField) {
		return <><label className={cssFormInputLabel}>{title}</label>
			<div class={cssFormInline}><label className={cssFormInputLabel} for={yearField}>Years:</label><input type={numberField} className={cssFormInputNumber} name={yearField} id={yearField} onChange={this.handleNotificationChange(stateCollectionName, i)} /></div>
			<div class={cssFormInline}><label className={cssFormInputLabel} for={monthField}>Months:</label><input type={numberField} className={cssFormInputNumber} name={monthField} id={monthField} onChange={this.handleNotificationChange(stateCollectionName, i)} /></div>
			<div class={cssFormInline}><label className={cssFormInputLabel} for={dayField}>Days:</label><input type={numberField} className={cssFormInputNumber} name={dayField} id={dayField} onChange={this.handleNotificationChange(stateCollectionName, i)} /></div>
			<div class={cssFormInline}><label className={cssFormInputLabel} for={dayPartField}>Hours and minutes:</label><input type={timeField} step="1" className={cssFormInputNumber} name={dayPartField} id={dayPartField} onChange={this.handleNotificationChange(stateCollectionName, i)} /></div></>
	}

	isReferralMessage(identifier) {
		return isNaN(+identifier);
	}

	reward(title, placeholder, name) {
		return posIntegration ? <label className={cssFormInputLabel}>
			{title}
			<Select
				className={cssFormInputDropdown}
				placeholder={placeholder}
				fluid
				selection
				search
				options={loyaltyOfferRewards}
				name={name}
				onChange={this.handleDropDownChange}
			/>
		</label> : "";
	}

	render() {

		let loyaltyOfferRulesDropdown = this.state.loading ? <p><em>Loading</em></p> : this.DisplayLoyaltyOfferRulesDropdown();

		let loyaltyOfferTarget = posIntegration ? <label className={cssFormInputLabel}>
			Loyalty Offer Target:
			<Select
				className={cssFormInputDropdown}
				placeholder='Select Loyalty Offer Target'
				fluid
				selection
				search
				options={loyaltyOfferTargets}
				name="loyaltyOfferTarget"
				onChange={this.handleDropDownChange}
			/>
			{this.state.errorLoyaltyOfferId && <p className={cssError}>{this.state.errorLoyaltyOfferId}</p>}
		</label> : "";
		let loyaltyOfferReward = posIntegration ? this.reward('Loyalty Offer Reward:', 'Select Loyalty Offer Reward', "loyaltyOfferDiscount") : "";
		let loyaltyOfferDetails;

		let steppedOfferDetails;

		let loyaltyOfferRuleDetails;

		let followUpMessagesDetails;

		if (this.state.loyaltyOfferRuleId == this.state.loyaltyReferralProgramId) {
			loyaltyOfferDetails = this.referralProgram();
		} else {
			loyaltyOfferDetails = <><label className={cssFormInputLabel}>
				Number Of Points to Earn Reward:
				<input type={numberField} className={cssFormInputNumber} name="numberOfPoints" value={this.state.numberOfPoints} onChange={this.handleInputChange} />
			</label>{this.state.errorNumberOfPoints &&
				//display an error here
				<p className={cssError} >{this.state.errorNumberOfPoints}</p>}</>
		}

		if (this.state.loyaltyOfferRuleId != this.state.loyaltyReferralProgramId) {
			steppedOfferDetails = <>
				{this.state.steppedOfferTiers.length > 0 ?
					<div><label className={cssFormInputLabel}>
						<input type={checkBox} className={cssFormCheckBox} name="displayNextSteppedOfferDescription" value={this.state.displayNextSteppedOfferDescription} onChange={this.handleInputChange} />Display Next Stepped Offer Description
					</label ></div> : ''}
				{this.state.steppedOfferTiers.map((item, i) => (
					<div key={i}> {posIntegration ? this.loyaltyOfferSteppedReward(i) : ""}
						<div>
							<label className={cssFormInputLabel}>Points to reach tier:<input className={cssFormInputNumber} name="numberOfStamps" type={numberField} step="1" value={item.numberOfStamps} onChange={this.handleSteppedOfferChange(i)} onFocus={this.handleFocusSelect} /></label>{item.errorNumberOfStamps && <p className={cssError}>{item.errorNumberOfStamps}</p>}
							<label className={cssFormInputLabel}>Tier Details:<input className={cssFormInputText} type="textarea" name="tierDetails" onChange={this.handleSteppedOfferChange(i)} maxLength={standardMinusTextLength} /></label>{item.errorTierDetails && <p className={cssError}>{item.errorTierDetails}</p>}
						</div>
						{this.steppedOfferDiscount(i, item)}
						<label className={cssFormInputLabel}>Icon File:<input type={fileFieldType} name="icon" onChange={this.handleSteppedFileChange(i)} className={cssFormInputFile} /></label>
						<label className={cssFormInputLabel}>Redeemed Icon File:<input type={fileFieldType} name="redeemedIcon" onChange={this.handleSteppedFileChange(i)} className={cssFormInputFile} /></label>
						<div><button type={buttonType} className={cssFormInputButton} onClick={this.handleRemoveSteppedOffer(i)}>Delete</button></div>
					</div>
				))}
				<button type={buttonType} className={cssFormInputButton} onClick={this.handleAddSteppedOfferTier}>Add Stepped Offer Tier</button>
			</>
		}

		followUpMessagesDetails = <>
			{this.state.followUpMessages.map((item, i) => this.message(item, i, "followUpMessages" + i, "followUpMessages"))}
			<button type={buttonType} className={cssFormInputButton} onClick={this.handleAddNotification("followUpMessages")}>Add Follow Up Message</button>
		</>


		if (this.state.loyaltyOfferRuleId == this.state.loyaltyOfferPeriodRewardId)
			loyaltyOfferRuleDetails = <><label className={cssFormInputLabel}>Period for reward to be available</label><br />
				<label className={cssFormInputLabel}>Years:<input className={cssFormInputNumber} type={numberField} name="years" id="years" value={this.state.years} onChange={this.handleInputChange} /></label>
				<label className={cssFormInputLabel}>Months:<input className={cssFormInputNumber} type={numberField} name="months" id="months" value={this.state.months} onChange={this.handleInputChange} /></label>
				<label className={cssFormInputLabel}>Days:<input type={numberField} className={cssFormInputNumber} name="days" id="days" value={this.state.days} onChange={this.handleInputChange} /></label>{this.state.errorTimePeriod && <p className={cssError}>{this.state.errorTimePeriod}</p>}</>

		if (this.state.loyaltyOfferRuleId == this.state.loyaltyReferralProgramId)
			loyaltyOfferRuleDetails = <><label className={cssFormInputLabel} />
			</>


		return (
			<>
				<NavMenu />
				<div><form onSubmit={this.handleSubmit} className={cssFormInput}>
					<label className={cssFormInputLabel}>
						Loyalty Offer Rules:
						{loyaltyOfferRulesDropdown}{this.state.errorLoyaltyOfferId && <p className={cssError}>{this.state.errorLoyaltyOfferId}</p>}
					</label>

					{this.state.loyaltyOfferRuleId != this.state.loyaltyReferralProgramId ? loyaltyOfferTarget : ''}
					{this.state.loyaltyOfferRuleId != this.state.loyaltyReferralProgramId ? loyaltyOfferReward : ''}


					<label className={cssFormInputLabel}>
						Loyalty Offer Details:
						<input className={cssFormInputText} type="textarea" name="offerDetails" id="offerDetails" value={this.state.offerDetails} onChange={this.handleInputChange} maxLength="1000" />
					</label>{this.state.errorSignUpAlertText && <p className={cssError}>{this.state.errorSignUpAlertText}</p>}
					{this.loyaltyOfferTargetDescription()}
					{loyaltyOfferDetails}{this.loyaltyOfferDiscount(this.state.loyaltyOfferDiscount, this.state)}
					{loyaltyOfferRuleDetails}


					{steppedOfferDetails}
					{followUpMessagesDetails}
					<input type="submit" className={cssFormInputButton} value="Save" disabled={this.state.submitButtonDisabled} />
					<img src={this.state.helpVisible ? HideHelp : ShowHelp} className="btn-help" onClick={this.toggleHelp} />
				</form>

					<p id="help" className={"collapse" + (this.state.helpVisible ? ".in" : "")}>
						Add this rule - when a customer spends the spend amount for a point, they will have the point automatically added to their card. Once they have earned the number of points they will be able to click on their voucher and scan the till's QR Code to redeem their voucher - the discount will automatically be applied to their shopping bill.</p>
				</div>
				{this.state.loading ? <img src={DualBallSpinner} alt="Loading" /> : ''}
				<div id="response" />
			</>
		);
	}
}